export default __webpack_public_path__ + "static/media/lanero.ae3d53a7.svg";